/*
----------------------------
Module - events-header
----------------------------
*/

import $ from 'jquery';
/*global fmg*/

(function(){
    'use strict';

    fmg.eventsHeader = function(){

        function refresh() {
            
            if (fmg.vars.screensize > 1) {

                if (typeof modal_dialog != "undefined") {
                    modal_dialog.close();
                }
                
            }    
            
        }
        
        function setupFilterButton() {

            $filter_btn.on("click", function(){

                var $this = $(this);
                var form_id = '#' + $this.parent().find('form').prop('id');
                
                $.magnificPopup.open({

                    showCloseBtn: false,
                    alignTop: true,

                    items: {
                        src: form_id,
                        type: 'inline'
                    }

                });

                // Store current instance of popup into variable
                modal_dialog = $.magnificPopup.instance;

            })

        }


        function setupDoneButton() {
            
            $done_btn.on("click", function(){

                if (typeof modal_dialog != "undefined") {
                    modal_dialog.close();
                }

            });

        }

        var $filter_btn = $(".page-header__filter-btn");
        var $done_btn = $(".events-header-form__done-btn");
        var modal_dialog;

        function init() {
            setupFilterButton();
            setupDoneButton();
        }

        return {
            init: init,
            refresh: refresh
        };

    }();

    document.addEventListener("DOMContentLoaded", function () {
        fmg.eventsHeader.init();
    });

}());


(function(){
    'use strict';

    window.fmg.eventsFiltering = function() { 

        var generateResults = fmg.fn.debounce(function () {

            // Prepare to make a call to funnelback for new results
            // We are adding each field's query string and joining them up later with &
            var new_requested_query_string_array = [];

            // Get selected regions in the form of a query string
            if ($event_region_filter.length) {

                var selected_regions_query_string = $event_region_filter.serialize();

                if (selected_regions_query_string.length) {
                    new_requested_query_string_array.push(selected_regions_query_string);
                }

            }
            
            // Get selected type in the form of a query string
            if ($event_type_filter.length) {

                var selected_types_query_string = $event_type_filter.serialize();
            
                if (selected_types_query_string.length) {
                    new_requested_query_string_array.push(selected_types_query_string);
                } else {
                    // If none is selected, need this facet GET param so that no events show
                    new_requested_query_string_array.push("f.Type%7CeventType=*")
                }

            }
                    
            // Get selected month and build proper funnelback gt lt meta query params
            if ($event_month_filter.length) {

                var selected_month = $event_month_filter.val();
                
                if (selected_month.length) {
                    
                    var selected_iso_date = new Date(selected_month);

                    // Store YYYYMMDD format of selected iso date first
                    // This must come first before the setMonth function applied below
                    // The original value is changed when it happens
                    var range_start_date = fmg.fn.formatToISODate(selected_iso_date);

                    // Add 1 month
                    var one_month_later_iso_date = new Date(selected_iso_date.setMonth(selected_iso_date.getMonth() + 1));
                    
                    var range_end_date = fmg.fn.formatToISODate(one_month_later_iso_date);

                    // This logic determines if dates of event overlap with given range
                    // eventMonth is just for prefilling the month picker and does not have effect on retrieving the results by month range. Thats what the lt_ and gt_ are for
                    var month_range_query_string = "eventMonth=" + selected_month + "&" + "lt_eventDateStartISO=" + range_end_date + "&" + "ge_eventDateEndISO=" + range_start_date;

                    new_requested_query_string_array.push(month_range_query_string);
                    
                }
                
            }
            
            // Make a copy of the basic search url endpoint
            var new_requested_search_endpoint = base_search_endpoint;

            var new_requested_query_string = new_requested_query_string_array.join("&");
            
            if (new_requested_query_string.length) {

                // Convert array into a string, joined by &, concatenate with source URL
                new_requested_search_endpoint = new_requested_search_endpoint + "&" + new_requested_query_string;

            }

            // Only ajax results if the next requested search is not the same as the previous one
            if (last_requested_search_endpoint !== new_requested_search_endpoint) {

                // Ajax results from endpoint and insert into container
                $event_results_inner.load(new_requested_search_endpoint, function() {

                    // Update URL without reload so that users can press back to last filtered view
                    window.history.replaceState("", "", "?" + new_requested_query_string);

                });

                // Remember the last request
                last_requested_search_endpoint = new_requested_search_endpoint;

            }

        }, 700);


        function setupEventRegionFilter() {

            $event_region_filter = $("[name='f.Region|eventRegion']");

            $event_region_filter.on("change", function() {

                generateResults();

            });

        }

        function setupEventTypeFilter() {

            $event_type_filter = $("[name='f.Type|eventType']");

            // Enable the checkboxes which are disabled by default
            $event_type_filter.prop("disabled", false);

            $event_type_filter.on("change", function() {

                generateResults();

            });

        }

        function setupEventMonthFilter() {

            $event_month_filter = $("[name='events-month']");

            $event_month_filter.on("change", function() {

                generateResults();

            });

        }

        function setupEventResetFiltersBtn() {

            $event_reset_filters_btn = $(".events-header-form__reset-btn");

            $event_reset_filters_btn.on("click", function() {

                resetEventFilters();

            });

        }

        function resetEventFilters() {

            // Clear focused class on form labels
            var $form_labels = $event_filters_form.find('label');

            var $selected_month = $(".flatpickr-monthSelect-month.selected");
            $form_labels.removeClass("form__label--focused-true");

            // Event region filter checkboxes
            // Reset button text to say "All"
            $event_filters_form.find('.list-box__button').removeClass("list-box__button--populated").text("All");
            $event_region_filter.prop('checked', false);

            // Event type filter checkboxes
            $event_type_filter.prop('checked', true);

            // Month picker
            // IMPORTANT: This is going to cause a "CHANGE" event which will trigger fmg.eventsFilter change event in setupEventMonthFilter function which in turn regenerates the results
            $event_month_filter[0]._flatpickr.clear();

            $selected_month.removeClass("selected"); 
            
        }

        function init() {

            $event_results_wrapper = $(".events-results");
            $event_filters_form = $("#events-header-form");
            
            if ($event_results_wrapper.length && $event_filters_form.length) {

                base_search_endpoint = $event_results_wrapper.data("search-endpoint");
                $event_results_inner = $event_results_wrapper.find(".events-results__inner")

                if ($event_results_inner.length && base_search_endpoint.length) {

                    // Only if .event-results__inner exists and theres a data-search-url then these filters can activate
                    setupEventRegionFilter();
                    setupEventMonthFilter();
                    setupEventTypeFilter();
                    setupEventResetFiltersBtn();

                }
                
            }

        }

        var $event_results_wrapper;
        var $event_results_inner;
        var base_search_endpoint;
        var last_requested_search_endpoint;

        var $event_filters_form;
        var $event_region_filter;
        var $event_month_filter;
        var $event_type_filter;
        var $event_reset_filters_btn;

        return {
            init: init
        };

    }();


    document.addEventListener("DOMContentLoaded", function () {
        window.fmg.eventsFiltering.init();
    });

}());